module.exports = "/static/assets/ef27c3f88d070cc1ce667f6b9ffb15bc.svg";